<template>
  <div class="d-flex flex-column">
    <span class="text-capitalize-first">
      {{ helper.trans(`antifraudalerts.rule.${alert.rule}`) }}
    </span>
    <div class="">
      <span>{{ data?.dealId }}</span> <copy-button :value="data?.dealId"></copy-button>
      <a :href="`${api.baseUrl()}/attachments/${data?.attachment}`" target="_blank" type="button" class="me-2 ms-2 text-warning"><i class="fa fa-paperclip"></i></a>
    </div>
    <div class="text-danger text-capitalize-first">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first">{{ helper.trans(`antifraudalerts.description.pay_out_receipt_verification_rule.reason.${data?.reason}`)}}</span>
    </div>
    <div class="text-danger text-capitalize-first">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first d-inline-block">{{ helper.trans('labels.trader_blocked')}}</span>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import CopyButton from "@/components/CopyButton.vue";
import PayOutReceiptVerificationDataDTO from "@/models/AntiFraud/PayOutReceiptVerificationDataDTO";
import APIClient from "@/service/APIClient";

const api = new APIClient()
export default defineComponent({
  name: "PayOutReceiptVerificationDescription",
  components: {CopyButton},
  props: {
    alert: {
      type: Object as PropType<AntiFraudAlertDTO>,
      default: null
    } as Prop<AntiFraudAlertDTO>,
  },
  setup(props) {
    const data = computed((): PayOutReceiptVerificationDataDTO | null => {
      if (!props.alert) {
        return null
      }

      return props.alert.data as unknown as PayOutReceiptVerificationDataDTO
    })

    return {
      helper,
      numberFormatter,
      data,
      api
    }
  }
})
</script>
